import styled from 'react-emotion';

export default styled('main')`
  background: ${({ theme }) => theme.colors.greys[7]};
  flex: 1 1 auto;
  padding-bottom: 2rem;
`;
